<div id="breadcrumb" class="division">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class=" breadcrumb-holder">

                    <!-- Breadcrumb Nav -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="demo-1.html">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Our Departments</li>
                        </ol>
                    </nav>

                    <!-- Title -->
                    <h4 class="h4-sm steelblue-color">Our Departments</h4>

                </div>
            </div>
        </div> <!-- End row -->
    </div> <!-- End container -->
</div>

<section id="services-7" class="bg-lightgrey wide-70 servicess-section division">
    <div class="container">

        <!-- SECTION TITLE -->
        <div class="row">
            <div class="col-lg-10 offset-lg-1 section-title">

                <!-- Title 	-->
                <h3 class="h3-md steelblue-color">Total Health Care Solutions</h3>

                <!-- Text -->
                <p>We offer complete healthcare services under one roof — from prevention to advanced treatment
                </p>

            </div>
        </div>


        <div class="row">

            <!-- SERVICE BOXES -->
            <div class="col-12">
                <div class="row">


                    <!-- SERVICE BOX #1 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="0.4s"
                            style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-137-doctor blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Top Level Doctors</h5>

                                    <!-- Text -->
                                    <p class="p-sm">Our team of top-level doctors brings expertise, experience, and excellence to every patient’s care
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #1 -->


                    <!-- SERVICE BOX #2 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="0.6s"
                            style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-076-microscope blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Modern Equipment</h5>

                                    <!-- Text -->
                                    <p class="p-sm"> We use modern medical equipment to ensure precise diagnosis and effective treatment
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #2 -->


                    <!-- SERVICE BOX #3 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="0.8s"
                            style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-065-hospital-bed blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Qualified Facilities</h5>

                                    <!-- Text -->
                                    <p class="p-sm">Our clinic offers fully qualified facilities designed to meet the highest standards of medical care
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #3-->


                    <!-- SERVICE BOX #4 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1s"
                            style="visibility: visible; animation-delay: 1s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-058-blood-transfusion-2 blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Professional Services</h5>

                                    <!-- Text -->
                                    <p class="p-sm">We provide professional medical services with a focus on quality, compassion, and patient satisfaction
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #4 -->


                    <!-- SERVICE BOX #5 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.2s"
                            style="visibility: visible; animation-delay: 1.2s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-141-clinic-history blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Medical Counseling</h5>

                                    <!-- Text -->
                                    <p class="p-sm">We offer expert medical counseling to guide patients toward informed, confident healthcare decisions
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #5 -->


                    <!-- SERVICE BOX #6 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.4s"
                            style="visibility: visible; animation-delay: 1.4s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-008-ambulance-6 blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Emergency Help</h5>

                                    <!-- Text -->
                                    <p class="p-sm"> Immediate emergency help available 24/7 to handle critical medical situations with speed and care
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #6 -->

                     <!-- SERVICE BOX #6 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.4s"
                            style="visibility: visible; animation-delay: 1.4s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-008-ambulance-6 blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Physiothrapy</h5>

                                    <!-- Text -->
                                    <p class="p-sm">Our physiotherapy services help restore movement, reduce pain, and improve your quality of life
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #6 -->

                     <!-- SERVICE BOX #6 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.4s"
                            style="visibility: visible; animation-delay: 1.4s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-008-ambulance-6 blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Ultrasound</h5>

                                    <!-- Text -->
                                    <p class="p-sm">High-quality ultrasound scans with quick reporting and professional care
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #6 -->

                     <!-- SERVICE BOX #6 -->
                    <div class="col-md-4">
                        <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.4s"
                            style="visibility: visible; animation-delay: 1.4s; animation-name: fadeInUp;">
                            <a>

                                <!-- Icon -->
                                <span class="flaticon-008-ambulance-6 blue-color"></span>

                                <!-- Text -->
                                <div class="sbox-7-txt">

                                    <!-- Title -->
                                    <h5 class="h5-sm steelblue-color">Pharmacy</h5>

                                    <!-- Text -->
                                    <p class="p-sm">Our in-house pharmacy provides genuine medicines and quick access to prescribed treatments
                                    </p>

                                </div>

                            </a>
                        </div>
                    </div> <!-- END SERVICE BOX #6 -->


                </div>
            </div> <!-- END SERVICE BOXES -->

        </div> <!-- End row -->
    </div> <!-- End container -->
</section>

<section id="banner-2" class="banner-section division">
    <div class="bg-scroll bg-inner bg-image division">
        <div class="container white-color">
            <div class="row d-flex align-items-center p-5">

                <!-- BANNER TEXT -->
                <div class="col-12 offset-lg-1">
                    <div class="banner-txt pc-30 wow fadeInUp" data-wow-delay="0.4s"
                        style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

                        <!-- Section ID -->
                        <span class="section-id id-color">Modern Medicine</span>

                        <!-- Title  -->
                        <h3 class="h3-lg">Better Technologies for Better Healthcare</h3>

                        <!-- Text -->
                        <p>We use the latest medical technology to improve accuracy, speed, and patient comfort
                            Our innovative tools ensure safer procedures and better treatment outcomes
                        </p>

                        <!-- Button -->
                        <a href="all-doctors.html" class="btn btn-tra-white blue-hover">View Our Doctors</a>

                    </div>
                </div> <!-- END BANNER TEXT -->


            </div> <!-- End row -->
        </div> <!-- End container -->
    </div> <!-- End Inner Background -->
</section>